import { Pipe, PipeTransform } from '@angular/core';
import { ProductSplashViewModel } from '@models/api-search.models';

@Pipe({
    name: 'isPreOrder',
    standalone: true
})
export class IsPreOrderPipe implements PipeTransform {
    transform(activeSplashes?: ProductSplashViewModel[] | null): boolean {
        return activeSplashes?.some(splash => splash?.type === 'ProductSplash2') ?? false;
    }
}
